// Types
import { ILineRoute } from 'common/lineRoute.interface';
import { IMonitoringData } from 'common/monitoring.interface';
import { DbdInterface } from '../dbds/types';
import { CarInterface } from '../fleet/types';
import { EmployeeInterface } from '../employees/types';
import {
  LineInterface,
  LineSectionBaseInterface,
  LineStopBaseInterface,
} from '../lines/types';
import { StopInterface } from '../stops/types';
import { ItineraryInterface } from '../itineraries/types';

/*
 * Action Types
 */
export enum TripTypes {
  LIST_TRIPS_DETAIL_REQUEST = '@trip/LIST_TRIPS_DETAIL_REQUEST',
  LIST_TRIPS_DETAIL_SUCCESS = '@trip/LIST_TRIPS_DETAIL_SUCCESS',
  LIST_TRIPS_DETAIL_FAILURE = '@trip/LIST_TRIPS_DETAIL_FAILURE',

  LIST_TRIPS_REQUEST = '@trip/LIST_TRIPS_REQUEST',
  LIST_TRIPS_SUCCESS = '@trip/LIST_TRIPS_SUCCESS',
  LIST_TRIPS_FAILURE = '@trip/LIST_TRIPS_FAILURE',

  GET_TRIPS_REQUEST = '@trip/GET_TRIPS_REQUEST',
  GET_TRIPS_SUCCESS = '@trip/GET_TRIPS_SUCCESS',
  GET_TRIPS_FAILURE = '@trip/GET_TRIPS_FAILURE',

  TRIPS_PDF_REQUEST = '@trip/TRIPS_PDF_REQUEST',
  TRIPS_PDF_SUCCESS = '@trip/TRIPS_PDF_SUCCESS',
  TRIPS_PDF_FAILURE = '@trip/TRIPS_PDF_FAILURE',

  TRIPS_PAYMENT_REQUEST = '@trip/TRIPS_PAYMENT_REQUEST',
  TRIPS_PAYMENT_SUCCESS = '@trip/TRIPS_PAYMENT_SUCCESS',
  TRIPS_PAYMENT_FAILURE = '@trip/TRIPS_PAYMENT_FAILURE',

  TRIPS_APROVAL_REQUEST = '@trip/TRIPS_APROVAL_REQUEST',
  TRIPS_APROVAL_SUCCESS = '@trip/TRIPS_APROVAL_SUCCESS',
  TRIPS_APROVAL_FAILURE = '@trip/TRIPS_APROVAL_FAILURE',

  TRIPS_APPROVAL_ALL_REQUEST = '@trip/TRIPS_APPROVAL_ALL_REQUEST',
  TRIPS_APPROVAL_ALL_SUCCESS = '@trip/TRIPS_APPROVAL_ALL_SUCCESS',
  TRIPS_APPROVAL_ALL_FAILURE = '@trip/TRIPS_APPROVAL_ALL_FAILURE',

  TRIP_REPORT_HTML_REQUEST = '@trip/TRIPS_REPORT_HTML_REQUEST',
  TRIP_REPORT_HTML_SUCCESS = '@trip/TRIPS_REPORT_HTML_SUCCESS',
  TRIP_REPORT_HTML_FAILURE = '@trip/TRIPS_REPORT_HTML_FAILURE',

  TRIP_REPORT_REQUEST = '@trip/TRIPS_REPORT_REQUEST',
  TRIP_REPORT_SUCCESS = '@trip/TRIPS_REPORT_SUCCESS',
  TRIP_REPORT_FAILURE = '@trip/TRIPS_REPORT_FAILURE',

  TRIP_UPDATE_CONTROL_REQUEST = '@trip/TRIP_UPDATE_CONTROL_REQUEST',
  TRIP_UPDATE_CONTROL_SUCCESS = '@trip/TRIP_UPDATE_CONTROL_SUCCESS',
  TRIP_UPDATE_CONTROL_FAILURE = '@trip/TRIP_UPDATE_CONTROL_FAILURE',

  TRIP_CONTROL_SETTINGS_REQUEST = '@trip/TRIP_CONTROL_SETTINGS_REQUEST',
  TRIP_CONTROL_SETTINGS_SUCCESS = '@trip/TRIP_CONTROL_SETTINGS_SUCCESS',
  TRIP_CONTROL_SETTINGS_FAILURE = '@trip/TRIP_CONTROL_SETTINGS_FAILURE',

  TRIP_CONTROL_SETTINGS_UPDATE_REQUEST = '@trip/TRIP_CONTROL_SETTINGS_UPDATE_REQUEST',
  TRIP_CONTROL_SETTINGS_UPDATE_SUCCESS = '@trip/TRIP_CONTROL_SETTINGS_UPDATE_SUCCESS',
  TRIP_CONTROL_SETTINGS_UPDATE_FAILURE = '@trip/TRIP_CONTROL_SETTINGS_UPDATE_FAILURE',

  CHANGE_KM_TYPE = '@trip/CHANGE_KM_TYPE',

  MONITORING_SETTINGS_REQUEST = '@trip/MONITORING_SETTINGS_REQUEST',
  MONITORING_SETTINGS_SUCCESS = '@trip/MONITORING_SETTINGS_SUCCESS',
  MONITORING_SETTINGS_FAILURE = '@trip/MONITORING_SETTINGS_FAILURE',

  MONITORING_SETTINGS_UPDATE_REQUEST = '@trip/MONITORING_SETTINGS_UPDATE_REQUEST',
  MONITORING_SETTINGS_UPDATE_SUCCESS = '@trip/MONITORING_SETTINGS_UPDATE_SUCCESS',
  MONITORING_SETTINGS_UPDATE_FAILURE = '@trip/MONITORING_SETTINGS_UPDATE_FAILURE',

  TRIP_ASK_MISSING_ENTRIES = '@trip/TRIP_ASK_MISSING_ENTRIES',
}

/*
 * Data types
 */
export interface LineSectionInterface extends LineSectionBaseInterface {
  Line: LineInterface;
  Itineraries?: ItineraryInterface[];
}

export interface EntriesInterface {
  payments: {
    BUTTON: { quantity: number; value: number };
    EMV: { quantity: number; value: number };
    EXTERN: { quantity: number; value: number };
    TOKEN: { quantity: number; value: number };
    TRANSPORT_CARD: { quantity: number; value: number };
  };
  benefits: object;
}

export interface EntriesResumeInterface {
  entries: EntriesInterface;
  owned: number;
  quantity: number;
  paidValue: number;
  totalValue: number;
  transactionedValue: number;
  types: object;
}

export interface TripEntryInterface {
  id: string;
  usedAt: string;
  usedDate?: string;
  latitude: number;
  longitude: number;
  value: number;
  isVt?: number;
  paymentType?: number;
  timeout?: boolean;
  number?: string;
  integrationGroupId?: string | null;
  firstAndSecond?: string | null;
  createdAt: string;
  updatedAt: string;
  fareTaxId?: string | null;
  dbdId: string;
  lineStopId?: string;
  lineSectionId: string;
  tripId: string;
  entryTripId?: string;
  transportOperatorId?: string;
  lineMatrixIntegrationId?: string | null;
  benefitId?: string | null;
  fareBonusId?: string | null;
  userId?: string | null;
  DbdTransportCardEntry?: object | null;
  DbdTokenEntry?: object | null;
  DbdEmvEntry?: {
    id: string;
  } | null;
  DbdButtonEntry?: object | null;
  DbdExternEntry?: object | null;
  DbdExitEntry?: {
    id: string;
    createdAt: string;
    updatedAt?: string;
    entryId?: string;
  } | null;
  Benefit?: {
    id: string;
    name: string;
    data?: string;
  } | null;
  LineMatrixIntegration?: object | null;
  Dbd?: DbdInterface;
}

export interface DbdInvalidEntryInterface {
  id: string;
  payload: string;
  result: string;
  type: string;
  dbdId: string;
  userId: string;
  cardId: string;
  failedNumber: number;
  usedAt: string;
  createdAt: string;
  updatedAt: string;
  tripId: string;
  Dbd?: DbdInterface;
}

export interface TripBaseInterface {
  id: string;
  title: string;
  status: number;
  approvalStatus: number;
  startedAt: string;
  closedAt: string;
  km: number;
  idleKm: number;
  createdAt: string;
  updatedAt: string;
  employeeId: string | null;
  lineSectionId: string | null;
  dbdId: string | null;
  carId: string | null;
  blockId: string | null;
  transportOperatorId: string;
}

export interface TripOccurrencesLineStopInterface
  extends LineStopBaseInterface {
  Stop: StopInterface;
}
export interface TripOccurrencesInterface {
  id: string;
  latitude: number;
  longitude: number;
  type: number;
  occurrenceDatetime: string;
  expectedDatetime: string;
  createdAt: string;
  updatedAt: string;
  tripId: string;
  lineStopId: string;
  LineStop: TripOccurrencesLineStopInterface;
}

export interface TripMetricsInterface {
  id: string;
  value: number; // 0 - 100%
  type: number;
  createdAt: string;
  updatedAt: string;
}

export interface TripControl {
  id: string;
  startKm: number;
  startKmPhoto: string;
  endKm: number;
  endKmPhoto: string;
  resultKm: number;
  startEntryCount: number;
  startEntryCountPhoto: string;
  endEntryCount: number;
  endEntryCountPhoto: string;
  resultEntryCount: number;
  startExitCount: number;
  endExitCount: number;
  startExitCountPhoto: string;
  endExitCountPhoto: string;
  resultExitCount: number;
  startArmDrop?: number;
  endArmDrop?: number;
  resultArmDrop?: number;
  rollsArmDrop?: number;
  startArmExitDrop?: number;
  endArmExitDrop?: number;
  resultArmExitDrop?: number;
  rollsArmExitDrop?: number;
  createdAt: string;
  updatedAt: string;
  tripId: string;
  employeeId: string;
  lineSectionId: string;
}
export interface TripControlSettings {
  id: string;
  startKm: number;
  startKmPhoto: number;
  endKm: number;
  endKmPhoto: number;
  startEntryCount: number;
  endEntryCount: number;
  startEntryCountPhoto: number;
  endEntryCountPhoto: number;
  startExitCount: number;
  endExitCount: number;
  startExitCountPhoto: string;
  endExitCountPhoto: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  seccionedNeeded: boolean | null;
}
export interface TripInterface extends TripBaseInterface {
  tripDataUrl: string | null;
  Dbd?: DbdInterface;
  Car?: CarInterface;
  TripOccurrences: Array<TripOccurrencesInterface>;
  TripMetrics: Array<TripMetricsInterface>;
  LineSection?: LineSectionInterface;
  TransportEmployee?: EmployeeInterface;
  EntriesResume?: EntriesResumeInterface;
  Entries?: TripEntryInterface[];
  DbdInvalidEntries?: DbdInvalidEntryInterface[];
  TransportEmployeePayments?: any[];
  TransportEmployeePaymentTrips?: TransportEmployeePaymentTripsInterface[];
  TransportEmployeeTransactions?: any[];
  TripControl?: TripControl;
  LineRoute?: ILineRoute; // way route
  TripRoute?: IMonitoringData[];
  totalPassengers?: number;
  totalExitPassengers?: number;
  TripSchedule: { start: string; end: string } | null;
  beginAt?: string;
  Gate?: TripGateInterface | null;
}
export interface TripGateInterface {
  id: string;
  title: string | null;
  Block?: {
    id: string;
    name: string;
    Terminal?: { id: string; name: string; shortName: string | null } | null;
  } | null;
}
export interface TransportEmployeePaymentTripsInterface {
  id: string;
  value: number;
  createdAt: string;
  updatedAt: string;
  paymentId: string;
  tripId: string;
}

export interface TripReportInterface extends TripBaseInterface {
  ipk: number | null;
  ipke: number | null;
  valuePerKm: number | null;
  kvd: number | null;
  pvd: number | null;
  parentId: string;
  Dbd?: DbdInterface;
  Car?: CarInterface;
  LineSection?: LineSectionInterface;
  TransportEmployee?: EmployeeInterface;
  EntriesResume?: EntriesResumeInterface;
  Entries?: any[];
  TransportEmployeePayments?: any[];
  TransportEmployeeTransactions?: any[];
  totalPassengers?: number;
}

export interface MonitoringSettingsInterface {
  id: string;
  year: number;
  month: number;
  type: number;
  value: number;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
}

export type KmType = 'total' | 'discriminated' | '';

/*
 * State type
 */
export interface TripsState {
  readonly tripDetailsList: TripInterface[];
  readonly tripReportControl: TripControl;
  readonly tripControlSettingsData: TripControlSettings;
  readonly tripList: TripInterface[];
  readonly tripListFull: TripInterface[];
  readonly tripData: TripInterface;
  readonly tripReportHtml: string;
  readonly tripReport: TripReportInterface[];
  readonly kmType: KmType;
  readonly monitoringSettingsList: MonitoringSettingsInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly loadingTripDetails: boolean;
  readonly error: boolean;
}
